import { z } from 'zod'

export const lessonPlanSchema = z.object({
  id: z.string().regex(/^[a-fA-F0-9]{24}$/),
  chapter: z.coerce.number(),
  videoLink: z.string().nullish(),
  presentationLink: z.string().nullish(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
  deletedAt: z.date().nullish()
})

export const createLessonPlanSchema = lessonPlanSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true
})

export const updateLessonPlanSchema = createLessonPlanSchema.partial()
